import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {
  DEFAULT_SCROLL_SPEED,
  HISTORY_KEY_SEARCH_VIDEO,
  LINK_TYPE,
  LinkInfo2,
  LIST_TYPE,
  SearchParam
} from '../../shared/defines/client.const';
import {IsEmptyVar} from '../../shared/defines/common.func';
import {NormalizeSearchParamKeyword} from '../../shared/defines/search-keyword.func';
import {Video} from '../../shared/models/video.model';
import {LayoutMgrService} from '../../shared/services/layout-mgr/layout-mgr.service';
import {YoutubeService} from '../../shared/services/youtube/youtube.service';
import {VideoLoader} from '../../shared/interfaces/VideoLoader';
import {VideoService} from '../../shared/services/video/video.service';
import {VideoBookmarkService} from '../../shared/services/video/video-bookmark.service';
import {VideoHistoryService} from '../../shared/services/video/video-history.service';
import {ScrollDownService} from "../../shared/services/scroll-down/scroll-down.service";
import {FOOTER_ON} from '../../shared/components/footer/footer.component';


@Component({
  selector: 'app-movie-search',
  templateUrl: './movie-search.component.html',
  styleUrls: ['./movie-search.component.scss']
})
export class MovieSearchComponent implements OnInit, OnDestroy {
  @ViewChild('container') container: ElementRef;

  public keyword: string;
  public placeholder: string;
  public emptyMsg: string;
  HistoryKeySearch = HISTORY_KEY_SEARCH_VIDEO;

  public listVideo: Array<Video> = null;
  private subscription: Subscription = null;
  public get IsLoading(): boolean {
    // console.log('IsLoading()', this.subscription, this.subscription !== null);
    return !IsEmptyVar(this.subscription);
  }

  protected sendingBookmark = false;

  private inited = false;
  private type: LIST_TYPE = null;
  public vl: VideoLoader;

  // 라우터에서 넣어주는 값. (TODO: 초기화에 유의해야 함)
  private queryParams: SearchParam = null;
  private queryParams$: Subscription = null;
  private routeParams$: Subscription = null;

  // 푸터의 아래로 내리기 버튼 구독
  private scrollDown$: Subscription | null = null;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private youtube: YoutubeService,
    public lm: LayoutMgrService,
    private videoSvc: VideoService,
    private bmSvc: VideoBookmarkService,
    private historySvc: VideoHistoryService,
    private scrollDownSvc: ScrollDownService,
    // private naviSvc: NavigationService,
  ) {

    // 이 페이지에 있는데, router.navigate()를 호출하면 이 코드가 다시 불려진다.
    // (주의) 처음 초기화 할 때에도 불려진다.
    this.queryParams$ = this.route.queryParams
      .subscribe(params => {
        console.log('MovieSearchComponent::queryParams', params);

        this.queryParams = NormalizeSearchParamKeyword({...params});
        delete this.queryParams.serial;

        this.type = this.queryParams?.l ?? LIST_TYPE.SERVER;

        if (this.inited) {  // 이미 화면에 초기화 되어있는 경우!
          // TODO: 현재 목록에 존재하면 해당 영상의 위치로 이동, 없다면 이력 화면으로 이동시킴.
          this.init();
        }
      });


    // 처음 이 페이지에 들어올 때 불려진다.
    // url이 변경되어도 불린다. type이 변경되어도 주소가 바뀐 것이므로 이 함수가 불린다.
    // queryParams가 바뀐 것으로는 여기가 불려지지 않는다.
    this.routeParams$ = route.params.subscribe(params => {
      console.log('MovieSearchComponent params =', params);

      this.inited = true;

      this.init();
    });

    lm.Reset();
  }

  ngOnInit(): void {
    // 푸터의 스크롤 버튼 처리.
    this.scrollDown$ = this.scrollDownSvc.pushScrollDown$().subscribe(isFirst => {
      const scrollDelta = DEFAULT_SCROLL_SPEED * (isFirst ? 2 : 1);  // 스크롤 시작할 때 첫번째는 두배로 스크롤 함.

      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + scrollDelta,
        behavior: 'auto',
      });
    });
  }

  ngOnDestroy(): void {
    this.lm.CloseYoutubePopup();

    if (this.queryParams$) {
      this.queryParams$.unsubscribe();
      this.queryParams$ = null;
    }
    if (this.routeParams$) {
      this.routeParams$.unsubscribe();
      this.routeParams$ = null;
    }

    this.scrollDownSvc.popScrollDown$();
    if (this.scrollDown$) {
      this.scrollDown$.unsubscribe();
      this.scrollDown$ = null;
    }
  }

  private init(): void {
    console.log('MovieSearchComponent::init()', this.queryParams);

    let param: SearchParam = null;
    if ('id' in this.queryParams) {
      param = {id: this.queryParams.id};
    }
    else if ('keyword' in this.queryParams) {
      this.keyword = this.queryParams.keyword;
      param = {keyword: this.keyword};
    }

    if ('cat' in this.queryParams) {
      param = {...param, cat: this.queryParams.cat};
    }

    switch (this.type) {
      case LIST_TYPE.SERVER:
        this.vl = this.videoSvc;
        this.placeholder = '영상을 검색 합니다.';
        this.emptyMsg = '영상이 없습니다.';
        this.keyword = this.queryParams.keyword;
        this.ReloadList(param);
        break;
      case LIST_TYPE.BOOKMARK:
        this.vl = this.bmSvc;
        this.placeholder = '영상을 검색 합니다.';
        this.emptyMsg = '영상이 없습니다.';
        this.keyword = this.queryParams.keyword;
        this.ReloadList(param);
        break;
      case LIST_TYPE.HISTORY:
        this.vl = this.historySvc;
        this.placeholder = '영상을 검색 합니다.';
        this.emptyMsg = '영상이 없습니다.';
        this.ReloadList();
        break;
      default:
        console.error('MovieSearchComponent invalid type', this.type);
        break;
    }
  }

  public onGoHistory(): void {
    // console.warn('navigate(/movie-search) - MovieSearchComponent::onGoHistory()', this.type);

    const queryParams: SearchParam = {l: LIST_TYPE.HISTORY};
    this.router.navigate(['/movie-search'], {queryParams}).then();
  }

  public GetFooterOn(): FOOTER_ON {
    return this.vl instanceof VideoBookmarkService ? FOOTER_ON.BOOKMARK : FOOTER_ON.MOVIE_COLLECT;
  }

  /****************************************************************************
   * 동영상 목록 로딩 처리.
   ****************************************************************************/

  public onSearch(param: SearchParam): void {
    // if (this.vl instanceof VideoHistoryService && 'keyword' in param) {
    //   this.router.navigate(['/movie-search', LIST_TYPE.SERVER], {
    //     queryParams: param,
    //   }).then();
    //   return;
    // }

    // console.warn('navigate(/movie-search) - MovieSearchComponent::onSearch()', param, this.vl);
    const queryParams: SearchParam = {
      ...NormalizeSearchParamKeyword(param),
      l: LIST_TYPE.SERVER,
    };
    this.router.navigate(['/movie-search'], {queryParams}).then();
  }

  public ReloadList(param: SearchParam = null): void {
    // console.log('MovieSearchComponent::ReloadList() param =', param);

    if (this.subscription) {
      console.warn('MovieSearchComponent::ReloadList() already loading');
      return;
    }

    this.listVideo = null;

    this.subscription = this.vl.GetList(param ? NormalizeSearchParamKeyword(param) : null)
      .pipe(
        finalize(() => this.subscription = null)
      ).subscribe((listVideo: Array<Video>) => {
        // console.log('MovieSearchComponent::ReloadList() listVideo =', listVideo);
        this.listVideo = listVideo;
      }, (err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.subscription = null;
          console.log('MovieSearchComponent::ReloadList() 404', this.subscription, this.IsLoading);
        }
        else {
          console.error(err);
        }
      });
  }

  public ToggleBookmark(video: Video): void {
    // console.warn('MovieSearchComponent::ToggleBookmark()', video, this.vl);
    if (this.sendingBookmark) {
      return;
    }
    this.sendingBookmark = true;

    video.bookmark = !video.bookmark;

    if (!video.bookmark && this.vl instanceof VideoBookmarkService) {
      // 책갈피 화면이라면 현재 책갈피 해제된 항목을 지운다.
      this.listVideo.splice(this.listVideo.indexOf(video), 1);
    }

    this.bmSvc.sendBookmark(video.no, video.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => console.log(data),
      err => console.error(err)
    );
  }
}
